









































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import store from '@/services/store';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

// Вкладка "Расходы ГККП" режима "Форма ГУ" (UC.eAk.GUF.06). Реализована по образцу вкладки "Расходы"
// (budget-sum-calc-cost-table.vue), но данные (в т.ч. плановые суммы cur_year..cur_year+2) приходят
// уже готовыми одним запросом свода ГККП - расчёт прогноза (calcProgn/get-req-total) здесь не требуется.
@Component({
    name: 'c-bud-sum-calc-gkkp-expens-tab',
    components: {
    }
})
export default class CBudgetSumCalcGkkpExpensTab extends Vue {
    @Prop({
        required: true,
        default: {}
    })
    private filter!: any;

    @Prop({
        required: false,
        default: true
    })
    private edited!: boolean;

    private editable0: boolean | null = null;
    private editable1: boolean | null = null;

    private progress = 0;

    private firstEdit = false; // началось ли редактирование

    private curYear = (new Date()).getFullYear();

    private curDataType: string | null = null;
    private curGr: number | null = null;
    private curAbp: number | null = null;
    private curBin: string | null = null; // БИН выбранного ГККП
    private curProg: number | null = null;
    private curSubProg: number | null = null;
    private region = '450101';
    private variantEndDate: any | null = null;
    private variantStartDate: any | null = null;

    private calcData: any[] = [];
    private curVariant: string | null = null;
    private versYear: number | null = null;

    private totalSum: any = { kass_ras: 0, fact_ras: 0, utoch_plan: 0, plan_year0: 0, plan_year1: 0, plan_year2: 0 };

    private newRowData: any = { kass_ras: 0, fact_ras: 0, utoch_plan: 0 };

    // --------------Спецификация -------- (переиспользуются эндпоинты вкладки "Расходы" - разрез-независимые)
    private spfMap: Map<number, any> = new Map();
    private spfBaseMap: Map<number, any> = new Map();
    private spfBase: any[] = [];
    private curSpf: any | null = null;

    private getSpfLst(): any[] {
        const newArr = JSON.parse(JSON.stringify(Array.from(this.spfMap.values())));
        for (const el of this.calcData) {
            for (let i = 0; i < newArr.length; i++) {
                if (el.spf === newArr[i].spf) {
                    newArr.splice(i, 1);
                    break;
                }
            }
        }
        return newArr;
    }

    private get spfLst() {
        const newArr = this.getSpfLst();
        const result: any[] = [];
        for (const el of newArr) {
            result.push(setNameLang(this.$i18n.locale, el, 'spf'));
        }
        return result;
    }

    private async loadEditable(spf: number) {
        const params = { spf: spf, curYear: this.curYear }
        try {
            const response: any = await fetch(`/api-py/get-budget-sum-calc-spf-editable/${encodeURI(JSON.stringify(params))}`);
            const result = await response.json();
            return result;
        } catch (error) {
            makeToast(this, 'danger', this.tblTitle.error_editable, (error as Error).toString());
            this.progress = 0;
            return { editable0: false, editable1: false };
        }
    }

    // загрузка спецификаций (для кнопки "Добавить специфику")
    private async loadSpf() {
        let result: any = [];
        this.spfMap = new Map();
        this.spfBaseMap = new Map();
        try {
            const params = { date_b: `${this.curYear-2}-12-31`, date_e: this.variantEndDate, vers_year: this.versYear };
            const response: any = await fetch(`/api-py/dict-ebk-all-spf-actual/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
            this.spfBase = result;
            for (const el of result) {
                if (el.spf !== 0) {
                    let spfArr: any[] = this.spfBaseMap.get(el.spf);
                    if (!spfArr) { spfArr = []; }
                    spfArr.push(el);
                    this.spfBaseMap.set(el.spf, spfArr);

                    const spfEl = this.spfMap.get(el.spf);
                    if (!spfEl || (spfEl.end_date && (!el.end_date || new Date(el.end_date) > new Date(spfEl.end_date)))) {
                        this.spfMap.set(el.spf, el);
                    }
                }
            }
        } catch (error) {
            this.spfBase = [];
            this.spfMap = new Map();
            makeToast(this, 'danger', this.tblTitle.error_spf, (error as Error).toString());
        }
    }

    private async chgSpf() {
        this.editable0 = null;
        this.editable1 = null;
        if (!this.curSpf) { return; }
        const editObj: any = await this.loadEditable(this.curSpf.spf);
        this.editable0 = editObj.editable0;
        this.editable1 = editObj.editable1;
        this.newRowData = { kass_ras: 0, fact_ras: 0, utoch_plan: 0 };
    }

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    // приведение к числу, null/undefined/NaN -> 0
    private numOrZero(value: any): number {
        const num = parseFloat(String(value));
        return isNaN(num) ? 0 : num;
    }

    private recalcTotal() {
        const t: any = { kass_ras: 0, fact_ras: 0, utoch_plan: 0, plan_year0: 0, plan_year1: 0, plan_year2: 0 };
        for (const el of this.calcData) {
            t.kass_ras = Math.round((t.kass_ras + this.numOrZero(el.kass_ras)) * 100) / 100;
            t.fact_ras = Math.round((t.fact_ras + this.numOrZero(el.fact_ras)) * 100) / 100;
            t.utoch_plan = Math.round((t.utoch_plan + this.numOrZero(el.utoch_plan)) * 100) / 100;
            t.plan_year0 = Math.round((t.plan_year0 + this.numOrZero(el.plan_year0)) * 100) / 100;
            t.plan_year1 = Math.round((t.plan_year1 + this.numOrZero(el.plan_year1)) * 100) / 100;
            t.plan_year2 = Math.round((t.plan_year2 + this.numOrZero(el.plan_year2)) * 100) / 100;
        }
        this.totalSum = t;
    }

    // загрузка данных свода ГККП
    private async loadData() {
        this.progress = 25;
        this.calcData = [];
        this.recalcTotal();
        if (!this.curVariant) {
            makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.not_selected_vers);
            this.progress = 0;
            return;
        }
        if (!this.curBin) {
            makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.not_selected_bin);
            this.progress = 0;
            return;
        }
        const params = JSON.stringify({ curYear: this.curYear, region: this.region, abp: this.curAbp, gr: this.curGr, bin: this.curBin, prg: this.curProg, ppr: this.curSubProg, variant: this.curVariant, locale: this.$i18n.locale });
        let result: any[] = [];
        try {
            const response: any = await fetch(`/api-py/get-budget-consolidate-expens-gkkp/${encodeURI(params)}`);
            result = await response.json();
        } catch (error) {
            makeToast(this, 'danger', this.tblTitle.error_load_data, (error as Error).toString());
            this.progress = 0;
            return;
        }
        this.progress = 75;
        result.sort((a: any, b: any) => (a.spf > b.spf) ? 1 : -1);
        for (const el of result) {
            el._old = { kass_ras: el.kass_ras, fact_ras: el.fact_ras, utoch_plan: el.utoch_plan };
        }
        this.calcData = result;
        this.recalcTotal();
        this.progress = 100;
        this.curSpf = null;
        this.newRowData = { kass_ras: 0, fact_ras: 0, utoch_plan: 0 };
        this.firstEdit = false;
    }

    private mounted() {
        this.$watch('curSpf', this.chgSpf);
        if (this.filter) { this.chgFilter(this.filter); }

        this.$watch('firstEdit', async () => {
            this.$emit('changed', this.firstEdit);
        })
    }

    private async chgFilter(filter: any) {
        this.curAbp = filter.abp.abp;
        this.region = filter.region.code;
        this.curYear = parseInt(filter.curYear);
        this.curDataType = filter.dataType.code;
        this.curGr = filter.gr;
        this.variantEndDate = filter.variantEndDate;
        this.versYear = null;
        if (filter.curVariant) {
            this.curVariant = filter.curVariant.variant_uuid;
            this.variantStartDate = filter.curVariant.date_start;
            this.versYear = (this.curDataType == '2' ? filter.curVariant.year : null);
        }
        this.curBin = filter.gkkp ? filter.gkkp.bin : null;
        if (filter.prg !== null) { this.curProg = filter.prg.prg; } else { this.curProg = null; }
        if (filter.ppr !== null) { this.curSubProg = filter.ppr.ppr; } else { this.curSubProg = null; }
        this.calcData = [];
        await this.loadSpf();
        this.loadData();
    }

    private buildSaveRow(el: any): any {
        return {
            id: (el.id !== undefined && el.id !== null && el.id > 0) ? el.id : undefined,
            // eslint-disable-next-line @typescript-eslint/camelcase
            cur_year: this.curYear,
            gr: this.curGr,
            abp: this.curAbp,
            bin: this.curBin,
            prg: this.curProg,
            ppr: this.curSubProg,
            spf: el.spf,
            // eslint-disable-next-line @typescript-eslint/camelcase
            kass_ras: el.kass_ras,
            // eslint-disable-next-line @typescript-eslint/camelcase
            fact_ras: el.fact_ras,
            // eslint-disable-next-line @typescript-eslint/camelcase
            utoch_plan: el.utoch_plan,
            region: this.region,
            variant: this.curVariant,
            userId: this.usrId
        };
    }

    private getErrText(errCode: string | undefined, errTxt: string | undefined): string {
        switch (errCode) {
            case 'gkkp_expens_access_denied':
                return this.tblTitle.access_denied;
            case 'gkkp_expens_variant_not_actual':
                return this.tblTitle.variant_not_actual;
            case 'gkkp_expens_negative_value':
            case 'gkkp_expens_invalid_value':
                return this.tblTitle.invalid_value;
            default:
                return errTxt || this.tblTitle.saving;
        }
    }

    private async save() {
        const saveObj: any[] = [];
        if (this.curSpf && (this.newRowData.kass_ras || this.newRowData.fact_ras || this.newRowData.utoch_plan)) {
            this.addRow();
        }
        for (const el of this.calcData) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            el.kass_ras = this.truncateDecimal(el.kass_ras);
            // eslint-disable-next-line @typescript-eslint/camelcase
            el.fact_ras = this.truncateDecimal(el.fact_ras);
            // eslint-disable-next-line @typescript-eslint/camelcase
            el.utoch_plan = this.truncateDecimal(el.utoch_plan);
            if (el.id === undefined || el.id === null || el.id < 0) {
                if (!(!el.kass_ras && !el.fact_ras && !el.utoch_plan)) {
                    saveObj.push(this.buildSaveRow(el));
                }
            } else if (this.isChanged(el)) {
                saveObj.push(this.buildSaveRow(el));
            }
        }
        if (!saveObj.length) {
            makeToast(this, 'warning', this.tblTitle.saving, this.tblTitle.no_changes);
            this.loadData();
            return;
        }
        try {
            const url = '/api-py/budget-consolidate-expens-gkkp-save';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    // backend проверяет права по верифицированному Keycloak-токену (sub), а не по
                    // userId из тела запроса — без заголовка эндпоинт отвечает 401
                    Authorization: `Bearer ${this.$store.getters.token}`
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            let success = true;
            for (const r of response) {
                if (r.result !== 'success') {
                    success = false;
                    makeToast(this, 'danger', this.tblTitle.message, this.getErrText(r.errCode, r.errTxt));
                }
            }
            if (success) { makeToast(this, 'success', this.tblTitle.saving, this.tblTitle.success_saved); }
            this.loadData();
        } catch (error) {
            makeToast(this, 'danger', this.tblTitle.error_saving, (error as Error).toString());
        }
        this.firstEdit = false;
    }

    // усечение (не округление) дробной части до 1 знака после запятой
    private truncateDecimal(value: any): number {
        const num = parseFloat(String(value));
        if (isNaN(num)) { return 0; }
        const str = String(num);
        const dotIdx = str.indexOf('.');
        if (dotIdx === -1) { return num; }
        return parseFloat(str.slice(0, dotIdx + 2));
    }

    private isChanged(el: any): boolean {
        if (this.numOrZero(el.kass_ras) !== this.numOrZero(el._old ? el._old.kass_ras : null)) { return true; }
        if (this.numOrZero(el.fact_ras) !== this.numOrZero(el._old ? el._old.fact_ras : null)) { return true; }
        if (this.numOrZero(el.utoch_plan) !== this.numOrZero(el._old ? el._old.utoch_plan : null)) { return true; }
        return false;
    }

    private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const digitRegex = new RegExp('^\\d$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        const input = evt.target as HTMLInputElement;
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? input.value.length;
        // курсор сразу после запятой, дробная часть - единственный "0": заменяем его вводимой цифрой
        if (digitRegex.test(key) && start === end && input.value[start - 1] === '.' && input.value[start] === '0' && start === input.value.length - 1) {
            evt.preventDefault();
            const newValue = input.value.slice(0, start) + key + input.value.slice(start + 1);
            input.value = newValue;
            input.setSelectionRange(start + 1, start + 1);
            input.dispatchEvent(new Event('input'));
            return false;
        }
        // Расходы ГККП: только неотрицательные значения (в отличие от вкладки "Расходы" ГУ) - без "-?"
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^\\d*\\.?\\d{0,1}$');
        const newValue = input.value.slice(0, start) + key + input.value.slice(end);
        if (!regex.test(newValue)) {
            evt.preventDefault();
            return false;
        }
    }

    private chgValue(el: any, fieldName: string) {
        el[fieldName] = this.truncateDecimal(el[fieldName]);
        this.recalcTotal();
        if (!this.firstEdit) { this.firstEdit = true; }
    }

    private chgAddVal(fieldName: string) {
        if (parseFloat(String(this.newRowData[fieldName])).isNaN) { this.newRowData[fieldName] = 0; }
        this.newRowData[fieldName] = this.truncateDecimal(this.newRowData[fieldName]);
    }

    private addRow() {
        if (!this.curSpf) {
            makeToast(this, 'warning', this.tblTitle.message, this.tblTitle.choose_spec);
            return;
        }
        if (!this.editable0) {
            this.newRowData.kass_ras = 0;
            this.newRowData.fact_ras = 0;
        }
        if (!this.editable1) { this.newRowData.utoch_plan = 0; }
        const row: any = {
            id: -1,
            // eslint-disable-next-line @typescript-eslint/camelcase
            cur_year: this.curYear,
            gr: this.curGr,
            abp: this.curAbp,
            bin: this.curBin,
            prg: this.curProg,
            ppr: this.curSubProg,
            spf: this.curSpf.spf,
            // eslint-disable-next-line @typescript-eslint/camelcase
            spf_name: this.curSpf.name,
            // eslint-disable-next-line @typescript-eslint/camelcase
            kass_ras: this.newRowData.kass_ras,
            // eslint-disable-next-line @typescript-eslint/camelcase
            fact_ras: this.newRowData.fact_ras,
            // eslint-disable-next-line @typescript-eslint/camelcase
            utoch_plan: this.newRowData.utoch_plan,
            // eslint-disable-next-line @typescript-eslint/camelcase
            plan_year0: null,
            // eslint-disable-next-line @typescript-eslint/camelcase
            plan_year1: null,
            // eslint-disable-next-line @typescript-eslint/camelcase
            plan_year2: null,
            editable0: this.editable0,
            editable1: this.editable1,
            region: this.region,
            variant: this.curVariant,
            _old: { kass_ras: 0, fact_ras: 0, utoch_plan: 0 }
        };
        this.calcData.push(row);
        this.curSpf = null;
        this.newRowData = { kass_ras: 0, fact_ras: 0, utoch_plan: 0 };
        this.recalcTotal();
        if (!this.firstEdit) { this.firstEdit = true; }
    }

    // ---- переводы
    private getBudgetText(link: string) { return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            code: this.getBudgetText('sum_calc_edit.code'), // Код
            name: this.getBudgetText('sum_calc_edit.name'), // Наименование
            for_year: [
                this.getBudgetText('sum_calc_edit.for_year[0]'), // Отчет на
                this.getBudgetText('sum_calc_edit.for_year[1]'), // год
            ],
            kasRas: this.getBudgetText('sum_calc_abp.kasRas'), // Кассовые расходы
            factRas: this.getBudgetText('sum_calc_abp.factRas'), // Фактические расходы
            uochPlan_for: {
                val0: this.getBudgetText('sum_calc_abp.uochPlan_for.val0'), // Уточненный план на
                val1: this.getBudgetText('sum_calc_abp.uochPlan_for.val1'), //
            },
            planned_period: this.getBudgetText('sum_calc_edit.planned_period'), // Планируемый плановый период
            year: this.getBudgetText('sum_calc_abp.year'), // г.
            totalCost: this.getBudgetText('sum_calc_abp.totalCost'), // Всего затрат (тыс. теңге)
            choose_spec: this.getBudgetText('sum_calc_edit.choose_spec'), // Выберите специфику
            saving: this.getBudgetText('sum_calc_edit.saving'), // Сохранение
            no_changes: this.getBudgetText('sum_calc_edit.no_changes'), // Нет изменений для сохранения
            load_data: this.getBudgetText('sum_calc_edit.load_data'), // Загрузка данных
            not_selected_vers: this.getBudgetText('sum_calc_edit.not_selected_vers'), // Не выбрана версия бюджета
            not_selected_bin: this.getBudgetText('sum_calc_gkkp_expens.not_selected_bin'), // Не выбрано ГККП
            access_denied: this.getBudgetText('sum_calc_gkkp_expens.access_denied'),
            variant_not_actual: this.getBudgetText('sum_calc_gkkp_expens.variant_not_actual'),
            invalid_value: this.getBudgetText('sum_calc_gkkp_expens.invalid_value'),
            success_saved: this.getBudgetText('sum_calc_gkkp_expens.success_saved'),
            message: this.getBudgetText('sum_calc_gkkp_expens.message'), // Сообщение
            error_editable: this.getBudgetText('sum_calc_gkkp_expens.error_editable'), // Ошибка загрузки признаков редактирования специфики
            error_spf: this.getBudgetText('sum_calc_gkkp_expens.error_spf'), // Ошибка загрузки специфик
            error_load_data: this.getBudgetText('sum_calc_gkkp_expens.error_load_data'), // Ошибка загрузки свода расходов ГККП
            error_saving: this.getBudgetText('sum_calc_gkkp_expens.error_saving'), // Ошибка сохранения
        };
        return obj;
    }
}
